import {
  columnRoles,
  type PriceColumnRole,
} from '../UrlExcelMapper/UrlExcelMapper.types'
import type { ConfigFormInput } from './configFormModel'
import type { ConfigPriceFormValues } from './configPriceModel'
import { getSegmentIdsByColumn } from './configSegmentColumns'

export const DUPLICATE_COLUMN_MESSAGE = 'Такая колонка уже выбрана'

type StockColumnRole = (typeof columnRoles)[number]['value']

export type ColumnKey = StockColumnRole | PriceColumnRole | `segment:${number}`

export const getSegmentColumnKey = (columnNumber: string): ColumnKey =>
  `segment:${Number(columnNumber)}`

type ColumnEntry = { key: ColumnKey; column: number }

const toEntry = (key: ColumnKey, value: string): ColumnEntry[] =>
  value.trim() === '' ? [] : [{ key, column: Number(value) }]

export const collectColumnEntries = (
  stock: Pick<ConfigFormInput, StockColumnRole>,
  prices: Pick<
    ConfigPriceFormValues,
    PriceColumnRole | 'enabled' | 'currencyFromFile' | 'segments'
  >
): ColumnEntry[] => {
  const stockEntries = columnRoles.flatMap(({ value }) =>
    toEntry(value, stock[value])
  )
  if (!prices.enabled) return stockEntries

  const segmentEntries = Object.keys(
    getSegmentIdsByColumn(prices.segments)
  ).map((columnIndex) => {
    const column = Number(columnIndex) + 1
    return { key: getSegmentColumnKey(String(column)), column }
  })

  return [
    ...stockEntries,
    ...toEntry('purchaseColumnNumber', prices.purchaseColumnNumber),
    ...toEntry('rrcColumnNumber', prices.rrcColumnNumber),
    ...(prices.currencyFromFile
      ? toEntry('currencyColumnNumber', prices.currencyColumnNumber)
      : []),
    ...segmentEntries,
  ]
}

export const getConflictingColumnKeys = (entries: ColumnEntry[]) =>
  new Set(
    entries
      .filter((entry) =>
        entries.some(
          (other) => other.key !== entry.key && other.column === entry.column
        )
      )
      .map((entry) => entry.key)
  )
